if (!window.dynamicButtonsDefined) {
  const dynamicButtons = document.querySelectorAll('.nmh-dynamic-button[data-dynamic-position="true"]');
  const dynamicButtonsHeadlines = document.querySelectorAll('.article-template__content h1,.article-template__content h2');
  
  const dynButtonnumberOfHeadlines = dynamicButtonsHeadlines.length;
  const dynButtonnumberOfButtons = dynamicButtons.length;
  
  if( dynButtonnumberOfButtons > 0 && dynButtonnumberOfHeadlines > 0 ) {
    let buttonsPerHeadlines = parseInt(dynButtonnumberOfHeadlines / (dynButtonnumberOfButtons + 1));
    
    dynamicButtons.forEach((dynamicButton, dynamicButtonIndex) => {
      buttonsPerHeadlines = buttonsPerHeadlines * (dynamicButtonIndex + 1);
      dynamicButtonsHeadlines[buttonsPerHeadlines].insertAdjacentHTML("beforeBegin", dynamicButtons[dynamicButtonIndex].outerHTML);
      dynamicButtons[dynamicButtonIndex].remove()
    })
  }

  window.dynamicButtonsDefined = true;
}

/*
if (!customElements.get('nmh-dynamic-button')) {

  customElements.define('nmh-dynamic-button', class NMHDynamicButton extends HTMLElement {
    constructor() {
      super();

      console.log('nmh-dynamic-button constructor')
            
      const dynamicButtons = document.querySelectorAll('.nmh-dynamic-button');
      const dynamicButtonsHeadlines = document.querySelectorAll('.article-template__content h1,.article-template__content h2');
      
      const dynButtonnumberOfHeadlines = dynamicButtonsHeadlines.length;
      const dynButtonnumberOfButtons = dynamicButtons.length;
      
      console.log('dynButtonnumberOfHeadlines = ', dynButtonnumberOfHeadlines)
      console.log('dynButtonnumberOfButtons = ', dynButtonnumberOfButtons)
      
      if( dynButtonnumberOfButtons > 0 && dynButtonnumberOfHeadlines > 0 ) {
        let buttonsPerHeadlines = (dynButtonnumberOfHeadlines / (dynButtonnumberOfButtons + 1));
        console.log('buttonsPerHeadlines = ', buttonsPerHeadlines)
        
        dynamicButtons.forEach((dynamicButton, dynamicButtonIndex) => {
          buttonsPerHeadlines = buttonsPerHeadlines * (dynamicButtonIndex + 1);
          console.log('buttonsPerHeadlines = ', buttonsPerHeadlines)
          dynamicButtonsHeadlines[buttonsPerHeadlines].insertAdjacentHTML("beforeBegin", dynamicButtons[dynamicButtonIndex].outerHTML);
          dynamicButtons[dynamicButtonIndex].remove()
        })
      }

    }
  })
}
*/